<div mdbModal #DocsReferencia="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Ver Docs. Referencia
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

            <div class="card-body d-sm-flex p-1 justify-content-end">

              <div class="form-group row contador">
                <!-- <label for="ContEq" class="col-sm-3 col-form-label fontContador text-right font-weight-bold" size="sm">página {{ PagPosActual }} </label> -->


              <div class="d-sm-flex p-1">
                <button size="sm" mdbBtn type="button" color="danger" mdbWavesEffect class="btn btn-sm" (click)="OnDeleteDetail()">
                  <mdb-icon fas icon="trash"></mdb-icon>
                  <span *ngIf="countSelectDoc === 0"></span>
                  <span *ngIf="countSelectDoc > 0">( {{ countSelectDoc }} )</span>
                </button>

                <button [disabled]="listaDocRef?.length >= 20" size="sm" mdbBtn type="button" color="secondary" mdbWavesEffect class="btn btn-sm" (click)="AddDocs()">
                  <mdb-icon fas icon="plus"></mdb-icon>

                </button>
              </div>

            </div>

          </div>
            <div class="modal-body">
              <div class="card mb-2 wow">


                <!-- <div class="row" *ngIf="listaClientes.length === 0">
                    <div class="col">
                        <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                            No existen registros para el filtro seleccionado</a>
                    </div>
                </div> -->

                <table class="table table-striped table-hover table-bordered tab table-sm align-middle">
                    <thead class="grey lighten-2">
                        <tr>
                          <th scope="col" style="justify-content: center;width: 0%;">
                            <mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox>
                          </th>

                            <th scope="col">N°</th>
                            <th scope="col">Tipo Doc.</th>
                            <th scope="col">Fecha</th>
                            <th scope="col">Numero</th>
                            <th scope="col">Razón Ref.</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="listaDocRef?.length === 0">
                        <td colspan="100%" style="text-align: center">No se encuentran documentos referenciados</td>
                      </tr>
                      <tr *ngFor="let doc of listaDocRef; let indice=index">
                        <td style="justify-content: center;">
                          <mdb-checkbox [checked]="doc.checked"  (change)="checkDetalle(doc, $event)">
                          </mdb-checkbox>
                        </td>
                        <th>{{ indice+1 }}</th>
                        <td>{{doc.tipo_dte_codigo_nombre}}</td>
                        <td>{{doc.fecha_ref | fecha}}</td>
                        <td>{{doc.folio_str}}</td>
                        <td>{{doc.razon_ref}}</td>
                    </tr>
                        <!-- <tr *ngFor="let orden of listCompra">
                            <td>{{ cliente.rutFormato | rut }}</td>
                            <td>{{ cliente.nombre }}</td>
                            <td *ngIf="mode === 'RUT_SUCURSAL'">{{ cliente.direccion_completa }}</td>
                        </tr> -->
                    </tbody>
                </table>
            </div>

            <!-- DESACTIVAR BOTON AL DOC N° 20 -->
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="DocsReferencia.hide()" mdbWavesEffect>Cerrar</button>
            </div>
        </div>
    </div>
</div>

<app-modal-add-referencia (onListaDoc)="getDocRef($event)"></app-modal-add-referencia>
